import './index.scss';
import './popup.scss';

import Cookies from 'js-cookie';

import {
    createAutoplayVimeoIframe,
    createAutoplayYouTubeIframe,
    playHtmlVideoInLightbox,
} from '../fs-lightbox/video';

class VideoEmbedItem {
    constructor(root) {
        this.root = root;

        this.overlay = this.root.querySelector('.overlay');
        if (!this.overlay) { return; }

        this.type = this.overlay.dataset.videoType;
        this.code = this.overlay.dataset.videoCode;
        this.mp4 = this.overlay.dataset.videoMp4;

        this.overlay.addEventListener('click', (event) => {
            event.preventDefault();

            if (['vimeo', 'youtube'].includes(this.type) && this.code) {
                this.openEmbeded();
            } else if (this.type === 'upload' && this.mp4) {
                this.openUploaded();
            }
        });
    }

    openEmbeded() {
        if (this.getCookie(this.type)) {
            if (this.type === 'vimeo') { this.openVimeo(); }
            if (this.type === 'youtube') { this.openYouTube(); }
        } else {
            this.openConfirm();
        }
    }

    openUploaded() {
        this.openPopup(this.mp4, { autoplayVideo: true });
    }

    openConfirm() {
        let confirm = document.createElement('div');
        confirm.classList.add('videoembed-confirm');
        confirm.classList.add('frame-light-2');

        let content = document.createElement('div');
        content.classList.add('content');
        content.innerHTML = `<div class="richtext">
            <p>An dieser Stelle finden Sie einen externen Inhalt von ${this.getNameByType(this.type)}. Sie können
            ihn sich mit einem Klick anzeigen lassen. Hinsichtlich weiterer Details beachten Sie bitte die Hinweise
            auf den Seiten des externen Angebots.</p><p>Ich bin damit einverstanden, dass mir externe Inhalte
            angezeigt werden. Damit können personenbezogene Daten an Drittplattformen übermittelt werden.
            <a href="/datenschutzerklaerung">Mehr dazu in unserer Datenschutzerklärung</a>.</p>
        </div>`;

        let buttongroup = document.createElement('div');
        buttongroup.classList.add('buttongroup');

        let button = document.createElement('a');
        button.classList.add('button');
        button.classList.add('button--primary');
        button.href = 'javascript:;';
        button.innerHTML = 'Video starten';
        button.addEventListener('click', () => {
            this.setCookie(this.type, true);

            this.popup.close();
            this.popup = null;

            this.openEmbeded();
        });

        buttongroup.appendChild(button);
        content.appendChild(buttongroup);
        confirm.appendChild(content);

        this.openPopup(confirm);
    }

    openVimeo() {
        this.openPopup(createAutoplayVimeoIframe(this.code));
    }

    openYouTube() {
        this.openPopup(createAutoplayYouTubeIframe(this.code));
    }

    openPopup(source, { autoplayVideo = false } = {}) {
        this.popup = new FsLightbox();
        this.popup.props.sources = [source];

        if (autoplayVideo) {
            // Skip FsLightbox XHR type detection so <video> exists before onOpen.
            this.popup.props.types = ['video'];
            this.popup.props.onOpen = () => {
                playHtmlVideoInLightbox(this.popup);
            };
        }

        this.popup.open();

        let container = this.popup.elements.container;
        container.classList.add('wf-fslightbox-container');

        let close = document.createElement('button');
        close.classList.add('wf-fslightbox-close');
        close.innerHTML = `<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 26L26 2.00002" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
            <path d="M2 2L26 26" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
        </svg>`;
        close.addEventListener('click', () => {
            this.popup.close();
            this.popup = null;
        });

        container.appendChild(close);
    }

    setCookie(name, value) {
        Cookies.set(name, value ? 'true' : 'false', { expires: 90 });
    }

    getCookie(name) {
        return Cookies.get(name) === 'true' ? true : false;
    }

    getNameByType(type) {
        if (type === 'vimeo') { return 'Vimeo'; }
        if (type === 'youtube') { return 'YouTube'; }

        return '';
    }
}

window.app.run(() => {
    document.querySelectorAll('.videoembed-item').forEach((node) => {
        new VideoEmbedItem(node);
    });
});
